<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="
			modelId > 0 ? 'Edición tipo de servicio' : 'Nuevo tipo de servicio'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-tabs
			no-fade
			pills
			card
			small
			vertical
			nav-class="nav-style"
			align="center"
		>
			<b-tab title="General" active>
				<b-form @submit="onSubmit">
					<b-form-row>
						<b-form-group :disabled="unableEdit" class="col-4" label="Codigo">
							<b-form-input
								type="text"
								size="sm"
								v-model="modelInfo.code"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
							<b-form-input
								type="text"
								size="sm"
								v-model="modelInfo.name"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-4" label="Estado">
							<b-form-select
								size="sm"
								v-model="modelInfo.status"
								:options="statusOptions"
							></b-form-select>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group :disabled="unableEdit" class="col-2" label="Maximo de personas">
							<b-form-input
								type="number"
								size="sm"
								v-model="modelInfo.maxPax"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-2" label="Maximo de maletas">
							<b-form-input
								type="number"
								size="sm"
								v-model="modelInfo.maxSuitecases"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-2" label="Puntuacion">
							<b-form-select
								size="sm"
								v-model="modelInfo.score"
								:options="[1, 2, 3, 4, 5]"
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-3" label="Tipo de servicio">
							<b-form-select
								size="sm"
								v-model="modelInfo.serviceType"
								:options="serviceTypesOptions"
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-3" label="Categoria">
							<b-form-select
								size="sm"
								v-model="modelInfo.serviceTypeCategoryId"
								:options="categoryOpts"
							/>
						</b-form-group>
					</b-form-row>
					<!-- <hr />
						<FormTable  :fields="fields" label="Agregar un nuevo Expedia Id" v-model="modelInfo.expediaIds" />

						<FormTable class="mt-3"  :fields="fieldsJayRide" label="Agregar un nuevo Jayride Id" v-model="modelInfo.jayrideIds" />
					<hr /> -->
					<b-form-row>
						<b-form-group class="col-6" label="Descripcion general">
							<b-textarea
								size="sm"
								:disabled="unableEdit"
								v-model="modelInfo.description"
							/>
						</b-form-group>
						<b-form-group
							class="col-6"
							:disabled="unableEdit"
							label="Descripcion maletero"
						>
							<b-textarea
								size="sm"
								v-model="modelInfo.suitecasesDescription"
							/>
						</b-form-group>
					</b-form-row>
					<hr />
					<div class="text-right">
						<b-button :disabled="unableEdit" variant="primary" type="submit">{{
							modelId > 0 ? "Actualizar" : "Guardar"
						}}</b-button>
					</div>
				</b-form>
			</b-tab>
			<b-tab v-if="modelId > 0 && $hasPermission('serviceType.translation.show') && !embbebedOnSupplier" title="Traducciones">
				<TranslatableFields
					:unableEdit="unableEdit"
					:model-id="modelId"
					model-reference="service-types"
					:translatable-fields="translatableFields"
				/>
			</b-tab>
			<b-tab v-if="modelId > 0 && $hasPermission('serviceType.translation.show') && !embbebedOnSupplier" title="Imagen">
				<FilesRelated
					:unableEdit="unableEdit"
					:unableDelete="unableEdit"
					:model-id="modelId"
					model-reference="service-types"
					:file-keys="[{ label: 'Imagen', keyName: 'image' }]"
				/>
			</b-tab>
			<b-tab title="Mapeo" v-if="!embbebedOnSupplier">
				<RelationshipMapping :modelId="modelId"/>
			</b-tab>
		</b-tabs>
	</b-modal>
</template>

<script>
import TranslatableFields from "@/components/helpers/TranslatableFields";
import FilesRelated from "@/components/helpers/FilesRelated";
// import FormTable from './FormTable'
import RelationshipMapping from "@/components/sections/mapping/RelationshipMapping";

export default {
	props: {
		unableEdit: Boolean,
		embbebedOnSupplier: Boolean,
		supplierId: Number,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {
		TranslatableFields,
		FilesRelated,
		// FormTable,
		RelationshipMapping
	},
	data() {
		const defaultModelInfo = {
			id: -1,
			code: "",
			name: "",
			conf: {
				belongsTo: 'supplier',
				supplierId: ''
			},
			serviceType: "private",
			maxPax: 1,
			maxSuitecases: 1,
			score: 5,
			status: "active",
			expediaIds: "",
			jayrideIds: "",
			category: "standardCar",
			serviceTypeCategoryId:-1,
			description: "",
			suitecasesDescription: "",
			isShared: false
		};
		return {
			modelId: -1,
			loading: true,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			fields: [
				{ label: "Expedia Id", key: "id" },
				{
					label: "Actions",
					key: "action",
					tdClass: "text-right",
					thClass: "text-right"
				}
			],
			fieldsJayRide: [
				{ label: "JayRide Id", key: "id" },
				{
					label: "Actions",
					key: "action",
					tdClass: "text-right",
					thClass: "text-right"
				}
			],
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			],
			serviceTypesOptions: [
				{ value: "private", text: "Privado" },
				{ value: "shared", text: "Compartido" }
			],
			translatableFields: [
				{ label: "Nombre", field: "name", type: "inputText" },
				{
					label: "Descripción gral.",
					field: "description",
					type: "textarea"
				},
				{
					label: "Descripción maletero",
					field: "suitecasesDescription",
					type: "textarea"
				}
			]
		};
	},
	computed: {
		serviceTypesOpts() {
				return this.$root.auxVars.serviceTypesOpts.map(st => ({
					value: st.value,
					text: st.text
				}));
			},
		categoryOpts(){
			return this.$root.auxVars.serviceTypesCategoriesOpts;
		}
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			if(this.embbebedOnSupplier) {
				console.log(this.modelInfo)
				this.modelInfo.conf.supplierId = this.supplierId
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/service-types/${this.modelId}`
						: "/service-types",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert("OK!");
					this.$root.auxVars.resetResource("serviceTypesOpts");
					this.$root.auxVars.loadResourcesOpts({
						vm: this,
						resourceNames: ["serviceTypesOpts"],
						forceRefresh: true
					});
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},

		loadServiceType(id) {
			return this.$root.api.get(`/service-types/${id}`)
		},

		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.loadServiceType(this.modelId)
					.then(res => {
						if(this.embbebedOnSupplier) {
							this.modelInfo = { ...res.data, conf: {}};
						} else {
							this.modelInfo = { ...res.data }
						}
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesCategories']})
	}
};
</script>

<style></style>
